import React, { useEffect } from "react";
import { cyborgInit } from "./cyborgInit";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Cyborg = () => {
    const { t } = useTranslation();

    useEffect(() => {
        const onPageLoad = () => {
            cyborgInit();
        };

        if (document.readyState === "complete") {
            onPageLoad();
        } else {
            window.addEventListener("load", onPageLoad, false);
            return () => window.removeEventListener("load", onPageLoad);
        }
    }, []);

    const navigate = useNavigate();

    return (
        <div id="cyborg" className="cyborg stop">
            <div className="cyborg__messages">
                <span className="cyborg__text_1">{t("cyborg.p1")}</span>
                <span className="cyborg__text_2">{t("cyborg.p2")}</span>
                <span className="cyborg__text_3">{t("cyborg.p3")}</span>
                <span className="cyborg__text_4">{t("cyborg.p4")}</span>
                <span
                    className="cyborg__text_5"
                    onClick={() => navigate("/registration")}
                    style={{ cursor: "pointer" }}
                    dangerouslySetInnerHTML={{ __html: String(t("cyborg.p5")) }}
                ></span>
                <span className="cyborg__text_6">{t("cyborg.p6")}</span>
            </div>
            <canvas id="cyborg-canvas" width="200" height="285"></canvas>
        </div>
    );
};

export default Cyborg;
